import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import Input from '@hobs/components/Input';
import { RaisedButton } from '@hobs/components/Buttons';
import Styles from './ResetForm.module.scss';

class ResetForm extends React.Component {
  onSubmit = async (values, actions) => {
    const results = await this.props.onSubmit(values);

    if (results && !results.success) {
      actions.setSubmitting(false);
      actions.setErrors({
        form: results.payload.details
          ? results.payload.details[0].message[0]
          : results.payload.message
      });
    }
  };

  render() {
    const { translations } = this.props;
    return (
      <div className={Styles.form}>
        <Formik
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={{
            password: '',
            confirmPassword: '',
            form: null
          }}
          onSubmit={this.onSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <Field name="password" type="password" component={Input} large>
                {translations.password}
              </Field>
              <Field
                name="confirmPassword"
                type="password"
                component={Input}
                large
              >
                {translations.confirmPassword}
              </Field>

              <ErrorMessage
                className={Styles['error-label']}
                component="div"
                name="form"
              />

              <RaisedButton large type="submit" disabled={isSubmitting}>
                {translations.confirm}
              </RaisedButton>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

ResetForm.propTypes = {
  onSubmit: PropTypes.func,
  translations: PropTypes.object
};

export default ResetForm;
